'use strict';

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

module.exports = memoize;
//# sourceMappingURL=memoize.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/memoize/dist/memoize.cjs.js
// module id = 501
// module chunks = 170434399708630